import { serializeArrayToUrlParams } from './serialization-functions.model';

/**
 * Parameters for getting variable summaries
 */
export interface VariableSummariesParameters {
  /** Number of columns to query */
  collimit?: number;
  /** Column number to start at */
  coloffset?: number;
  /** Regular expression to search columns */
  cols?: Array<string>;
}

/**
 * Given VariableSummariesParameters, serialize them to be used as
 * URL parameters
 *
 * @param  options options to serialize
 * @returns serialized string as a urlParameter
 */
export function serializeVariableSummariesParameters(options: VariableSummariesParameters): string {
  if (!options) {
    return '';
  }
  let path = '';
  for (const prop in options) {
    if (options.hasOwnProperty(prop)) {
      const value = options[prop];
      switch (prop) {
        case 'cols':
          path += serializeArrayToUrlParams(prop, value);
          break;
        default:
          path += !prop || value === null || value === 'undefined' ? '' : `${prop}=${encodeURIComponent(value)}&`;
      }
    }
  }

  // Remove trailing ampersand
  if (path[path.length - 1] === '&') {
    path = path.substr(0, path.length - 1);
  }

  return path;
}
